/* eslint-disable no-bitwise, no-mixed-operators */

/**
 * @file UUID v4 generator https://stackoverflow.com/a/2117523/1333873.
 */
const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export default uuidv4;
